import{ORDER_DETAILS_PRIVATE_PATH}from"../constants/routes";/**
 * Generate route to order details.
 * @param {string} orderNumber The order number.
 * @returns {string}
 */export var getOrderDetailsRoute=function getOrderDetailsRoute(orderNumber){return"".concat(ORDER_DETAILS_PRIVATE_PATH,"/").concat(orderNumber);};